var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCalendarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm7.15-4.62v-.8c0-.41.34-.75.75-.75s.75.34.75.75v.59h2.71v-.59c0-.41.34-.75.75-.75s.75.34.75.75v.79c1.09.34 1.88 1.09 2.3 2.06.14.33-.1.71-.46.71H7.31c-.36 0-.6-.37-.46-.7.42-.97 1.21-1.72 2.3-2.06zm4.35 10.79h-3c-2.5 0-4-1.8-4-4v-2.53c0-.28.22-.5.5-.5h10c.28 0 .5.22.5.5v2.53c0 2.2-1.5 4-4 4z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCalendarCircle);
export default __webpack_public_path__ + "static/media/vuesax-bold-calendar-circle.6216367b89f8c2f57e89fdb0b55cb346.svg";
export { ForwardRef as ReactComponent };